import { startOfMonth, endOfMonth, format, type Locale } from 'date-fns';
import type { LimitPeriod } from '../model';

export type LimitPeriodRange = {
  isMonth: boolean;
  from: string;
  to: string;
};

export function getLimitPeriodRange(
  period: LimitPeriod,
  dateLocale: Locale
): LimitPeriodRange {
  const today = new Date();
  const dateFormat = 'dd MMM yyyy';

  const formatDate = (date: Date) =>
    format(date, dateFormat, { locale: dateLocale });

  switch (period) {
    case 'month': {
      const from = startOfMonth(today);
      const to = endOfMonth(today);

      return {
        isMonth: true,
        from: formatDate(from),
        to: formatDate(to),
      };
    }
    case 'day':
    case 'current':
    default:
      return {
        isMonth: false,
        from: formatDate(today),
        to: formatDate(today),
      };
  }
}
